import { z } from "zod";
import { SUPPLY_CHAIN_PARTNER_ROLES, type SupplyChainPartnerRole } from "@/contacts/ContactForm/validation";

export const contactFilterSchema = z.object({
  roles: z
    .array(z.enum(SUPPLY_CHAIN_PARTNER_ROLES as [SupplyChainPartnerRole, ...SupplyChainPartnerRole[]]))
    .transform((roleFilters) => (roleFilters?.length ? roleFilters : undefined))
    .optional(),
  types: z
    .array(z.string())
    .transform((typeFilters) => (typeFilters?.length ? typeFilters : undefined))
    .optional(),
  search: z.string().optional(),
});

export type ContactFilters = z.infer<typeof contactFilterSchema>;
